import { useTranslation } from 'react-i18next';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Button from '@amzn/awsui-components-react/polaris/button';

export interface DiscardChangesModalProps {
  visible: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function DiscardChangesModal({ visible, onConfirm, onDismiss }: DiscardChangesModalProps) {
  const { t } = useTranslation(['events', 'translation']);

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t('discardChangesModal.title')}
      closeAriaLabel={t('discardChangesModal.closeAriaLabel')}
      data-testid="discard-changes-modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              {t('discardChangesModal.dismiss')}
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              {t('discardChangesModal.confirm')}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {t('discardChangesModal.message')}
    </Modal>
  );
}
